import { useSelector } from 'react-redux';

import { useInsurance } from '~/pages/Settings/Insurance/hook';
import { getUserDataForFeatureTests } from '~/selectors/user.selectors';

import { type FeatureFlagUserData, type FeatureFlagUserDataPayload } from './types';

type UseUserDataForFeatureFlagHook = FeatureFlagUserDataPayload;

/**
 * This hook is designed to retrieve user data for feature flagging.
 * - If the user is logged in, it returns the user data object for feature flagging.
 * - If the user is not logged in, it returns the anonymous user data object for feature flagging.
 *
 * @returns {FeatureFlagUserDataPayload} The user data object for feature flagging.
 */
export const useUserDataForFeatureFlag = (): UseUserDataForFeatureFlagHook | null => {
  const { data: insuranceSettings } = useInsurance();
  const userData: FeatureFlagUserData | null = useSelector(getUserDataForFeatureTests);

  if (!userData) return null;

  const { id, ...otherAttributes } = userData;
  return {
    attributes: {
      ...otherAttributes,
      anonymous: false,
      environmentName: CONFIG.environmentName,
      insuranceByDefault: insuranceSettings?.is_auto_apply || false,
    },
    id: id.toString(),
  };
};
